import { useEffect, useState } from 'react';
import { getScreenMode } from '../helpers/utils';

const DEFAULT_SCREEN_MODE = '';

/**
 * This hook enables us to utilise the value of the screen mode from the helper function. The content is directly
 * related to the values in the body::before in utils.scss
 *
 * This just returns the actual value of the screen mode as mentioned previously
 * @returns {[null]}
 */
function useScreenMode() {
    const [screenMode, setScreenMode] = useState(DEFAULT_SCREEN_MODE);

    // This effect is only run once
    useEffect(() => {
        if (screenMode === DEFAULT_SCREEN_MODE) {
            // this will run first, any subsequent resize will call the function again, due to the event listener.
            setScreenMode(getScreenMode());
        }

        const resizeFunction = () => setScreenMode(getScreenMode());
        window.addEventListener('resize', resizeFunction);
        return () => window.removeEventListener('resize', resizeFunction);
    }, []);

    return [screenMode];
}

export default useScreenMode;



// WEBPACK FOOTER //
// ./hooks/use-screen-mode.js